export default __webpack_public_path__ + "static/media/SBilletera.af38a9c4.svg";